var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "discussionListContainer", staticClass: "container mb-5" },
    [
      _c("div", { staticClass: "k-tabs" }, [
        _c("ul", { staticClass: "k-tabs__list" }, [
          _c("li", { staticClass: "k-tabs__item k-tabs__item--active" }, [
            _c(
              "span",
              { staticClass: "k-tabs__link k-tabs__list--nohover" },
              [_vm._t("default")],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "k-tabs__actions" }, [
          _c(
            "a",
            {
              staticClass: "k-tabs__actions-link",
              attrs: { href: _vm.createDiscussionLink }
            },
            [
              _c(
                "svg",
                {
                  staticClass:
                    "k-tabs__actions-icon k-tabs__actions-icon--before",
                  attrs: { role: "img", width: "15", height: "15" }
                },
                [
                  _c("use", {
                    attrs: {
                      fill: "currentColor",
                      "xlink:href": "/images/spritesheet.svg#add"
                    }
                  })
                ]
              ),
              _vm._v("\n                   Přidat příspěvek\n               ")
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "k-table",
          attrs: { name: "list-complete", tag: "div" }
        },
        [
          _vm._l(_vm.discussions.data, function(discussion) {
            return _c(
              "div",
              { key: discussion.id, staticClass: "k-table__row" },
              [
                _c("div", { staticClass: "k-table__cell" }, [
                  _c("div", { staticClass: "k-table__cell-image" }, [
                    _c("img", {
                      attrs: {
                        src: discussion.user.prev_url,
                        alt: "",
                        height: "67px"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mr-auto" }, [
                    _c("a", { attrs: { href: discussion.url } }, [
                      _c("strong", { staticClass: "k-strong d-block mb-2" }, [
                        _vm._v(_vm._s(discussion.title))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "k-table__cell-meta ml-0" }, [
                      _vm._v("Vytvořený dne " + _vm._s(discussion.created_at))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "k-table__cell k-table__cell--info" },
                  [
                    _c("div", { staticClass: "k-table__cell-meta mx-0" }, [
                      _c("strong", { staticClass: "k-strong d-block mb-2" }, [
                        _vm._v(_vm._s(discussion.responses_count))
                      ]),
                      _vm._v(" "),
                      _c("div", {}, [_vm._v("odpovědí")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "k-table__cell k-table__cell--info" },
                  [
                    _c("div", { staticClass: "k-table__cell-meta mx-0" }, [
                      _c("strong", { staticClass: "k-strong d-block mb-2" }, [
                        _vm._v(_vm._s(discussion.views_count))
                      ]),
                      _vm._v(" "),
                      _c("div", {}, [_vm._v("zobrazení")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "k-table__cell k-table__cell--last-post text-left"
                  },
                  [
                    _c("div", { staticClass: "k-table__cell-meta mx-0" }, [
                      _vm._v(
                        "\n                           " +
                          _vm._s(discussion.latest_response_date) +
                          " od "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: discussion.latest_response_user.detail_url
                          }
                        },
                        [
                          _c("strong", { staticClass: "k-strong" }, [
                            _vm._v(_vm._s(discussion.latest_response_user.name))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-2" }, [
                        _vm._v("poslední příspěvek")
                      ])
                    ])
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm.discussions.data && _vm.discussions.data.length === 0
            ? _c("div", { key: "0", staticClass: "k-table__cell p-2" }, [
                _vm._v(
                  "\n               Nebyly nalezeny žádné příspěvky.\n           "
                )
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("pagination", {
        staticClass: "mt-5",
        attrs: { data: _vm.discussions, limit: 2 },
        on: { "pagination-change-page": _vm.paginate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }